/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sig_mode_draw = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draw`)
};

const es_sig_mode_draw = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dibujar`)
};

const de_sig_mode_draw = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeichnen`)
};

const nl_sig_mode_draw = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekenen`)
};

const fr_sig_mode_draw = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dessiner`)
};

const it_sig_mode_draw = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disegna`)
};

const pt_br2_sig_mode_draw = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desenhar`)
};

const pt_sig_mode_draw = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desenhar`)
};

const ja_sig_mode_draw = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`描く`)
};

const zh_sig_mode_draw = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`绘制`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sig_mode_draw = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sig_mode_draw(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sig_mode_draw", locale)
	if (locale === "en") return en_sig_mode_draw(inputs)
	if (locale === "es") return es_sig_mode_draw(inputs)
	if (locale === "de") return de_sig_mode_draw(inputs)
	if (locale === "nl") return nl_sig_mode_draw(inputs)
	if (locale === "fr") return fr_sig_mode_draw(inputs)
	if (locale === "it") return it_sig_mode_draw(inputs)
	if (locale === "pt-BR") return pt_br2_sig_mode_draw(inputs)
	if (locale === "pt") return pt_sig_mode_draw(inputs)
	if (locale === "ja") return ja_sig_mode_draw(inputs)
	return zh_sig_mode_draw(inputs)
};